module.exports = __webpack_public_path__ + "static/media/sunroof-active-no.7d9eb4cc.svg";